var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreeViewExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-1455 4169) rotate(180)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rounded_Rectangle_3_copy",
    "data-name": "Rounded Rectangle 3 copy",
    width: 29,
    height: 31,
    transform: "translate(-1484 4138)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAfCAYAAAAbW8YEAAAABHNCSVQICAgIfAhkiAAAAShJREFUSInF171Kw1AYBuAnraM/k3oHUl0dXAS9gKgICt3FwRsQpw6ZvIYOzkEnpVcgOCh1FeklOLprHRKLlmBrSU7eJVN44OTLx3ui4XBomsRp0sIetrGBZSxN9fJY5iZAEQ5wga1ZgH+hcZqsoYudsrA/0ThNjnGF+bJBaBSAp0irAiH6OUhxmhzlYLMq8Beaf8M+FqoEyY83n9JuCHCEyn6L0qd0EnoeCoRmv9Vo4TIk2pCttqBpyHZpcHSjDnSlDnSxDvS9DvStDvSlDvShDvQuONprd17xGBTNn8F3L9ziPhQ63hyeVdiNvjMqZr12Z4ATfARDc/gaZ/isEo2KrhXBey/02p0bbKpouArRHB5gF4d4KhMtPN6i5Le2fVnTWMeqGSvrFx/ASBDLBi3BAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M226.868,83.988,226.994,95,220,89.645Z",
    transform: "translate(-1692 4064)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeViewExpand);
export default __webpack_public_path__ + "static/media/Tree_view_expand.4ce9f2e894bbe410e55e4b10f7917db9.svg";
export { ForwardRef as ReactComponent };